import React from 'react'
import {
  Button,
  IconCallSplit24,
} from '@lightspeed/unified-components-helios-theme/react'
import { WithPopover } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { LineItemSplitQuantityPopover } from '../LineItemSplitQuantityPopover'
import {
  useLineItemSplitQuantityButtonModel,
  LineItemSplitQuantityButtonProps,
} from './useLineItemSplitQuantityButtonModel'

export const LineItemSplitQuantityButton = (
  props: LineItemSplitQuantityButtonProps
) => {
  const model = useLineItemSplitQuantityButtonModel(props)

  return (
    <div className="uc-base">
      <WithPopover direction="left" alignment="center">
        <Button
          appearance="ghost"
          type="button"
          disabled={model.disabled}
          onClick={() => model.setIsPopoverOpen(true)}
          prefixSlot={<IconCallSplit24 data-testid="split-quantity-icon" />}
          customDataAttributes={{
            container: {
              'data-track': 'line-item-split-quantity-button',
            },
          }}
        >
          <T _str="Split quantity" _context="Line item split quantity button" />
        </Button>

        <LineItemSplitQuantityPopover
          isOpen={model.isPopoverOpen}
          onClose={model.closePopover}
          onConfirm={model.handleSplitQuantity}
          lineItem={model.lineItem}
          splitQuantity={model.splitQuantity}
          inputError={model.inputError}
          onQuantityChange={model.handleQuantityChange}
          onQuantityError={model.handleQuantityError}
          hasError={model.hasError}
        />
      </WithPopover>
    </div>
  )
}
